import * as yup from "yup";
import i18n from "i18next";
import { initializeYup, INPUT_LENGTH } from "@duosoftbg/nacid-components";

export const codeValidationSchema = () => {
  initializeYup(yup);

  const baseUsernameValidationSchema = yup.object({
    id: yup.string().required(),
  });
  return baseUsernameValidationSchema;
};

export const createNationalUniversityValidationSchema = () => {
  yup.setLocale({
    string: {
      matches: i18n.t("validation.field.invalid"),
    },
    mixed: {
      default: i18n.t("validation.field.invalid"),
      required: i18n.t("validation.field.required"),
    },
  });

  return yup.object({
    id: yup.string().required().max(INPUT_LENGTH.MAX_INPUT_LENGTH_20, i18n.t("validation.charCount.invalid.20")),
    name: yup.string().required().max(INPUT_LENGTH.MAX_INPUT_LENGTH_255, i18n.t("validation.charCount.invalid.255")),
    nameEn: yup.string().required().max(INPUT_LENGTH.MAX_INPUT_LENGTH_255, i18n.t("validation.charCount.invalid.255")),
    address: yup.string().required().max(INPUT_LENGTH.MAX_INPUT_LENGTH_255, i18n.t("validation.charCount.invalid.255")),
    addressEn: yup
      .string()
      .required()
      .max(INPUT_LENGTH.MAX_INPUT_LENGTH_255, i18n.t("validation.charCount.invalid.255")),
    zipCode: yup.string().required().max(INPUT_LENGTH.MAX_INPUT_LENGTH_10, i18n.t("validation.charCount.invalid.10")),
    settlement: codeValidationSchema(),
    website: yup.string().required().max(INPUT_LENGTH.MAX_INPUT_LENGTH_255, i18n.t("validation.charCount.invalid.255")),
    isActive: yup.boolean().required(),
  });
};
